<div class="flex-1 input-app" [ngClass]="{'max-width-180': useMaxWidth}">
  <div
    (mouseenter)="showClear = true"
    (mouseleave)="showClear = false"
    class="edit-inline-row form-field-container"
    [ngClass]="{'clear-padding': useClearPadding}">
    <mat-form-field #matFormField
                    [ngClass]="{'color-blue': colorStyle.blue, 'color-anessa-blue': colorStyle.anessa_blue}"
                    floatLabel="never">
        <input matInput #valueControl="ngModel" [name]="name+'Input'"
               [id]="id+'_input'"
               type="text"
               placeholder="please enter"
               [(ngModel)]="inputDisplayValue"
               (ngModelChange)="onInputChange()"
               (focusin)="onInputFocusIn()"
               (focusout)="onInputFocusOut()"
               [disabled]="disabled"
               appValidateInputApp
               [inputChecks]="inputChecks"
               [selectValue]="selectValue"
               [setCustomErrorMessage]="customErrorMessage"
               (errorMessageUpdated)="updateValueValidity()"
               (errorMessageUpdate)="updateErrorMessage($event)"
               (validationUpdated)="touchValueControl()">
        <span matSuffix>{{inputSuffix}}</span>
      <mat-error>
        {{errorHint | anessaTranslation: trigger}}
      </mat-error>
      <ng-container *ngIf="selectOptions.length > 0">
        <mat-select
                    [id]="id+'_select'"
                    class="builtin-select"
                    disableOptionCentering panelClass="input-select-panel"
                    [name]="name+'Select'"
                    [(value)]="selectValue"
                    disableOptionCentering
                    [disabled]="disabled">
          <mat-select-trigger></mat-select-trigger>
          <mat-option *ngFor="let option of selectOptions"
                      class="text-center"
                      [value]="option"
                      (onSelectionChange)="onSelect($event)">
            {{option  | anessaTranslation: trigger}}
          </mat-option>
        </mat-select>
      </ng-container>
    </mat-form-field>
    <p *ngIf="inputValue && showClear && !disabled"
      class="form-field-clear"
      (click)="onClear()">
      clear
    </p>
  </div>
</div>
